import { Helmet } from "react-helmet";
import { Heading, Img } from "../../components";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import SolutionTable from "./SolutionTable";

export default function Solutions() {
  return (
    <>
      <Helmet>
        <title>Portfolio Dashboard – Manage Your Investments Effectively</title>
        <meta
          name="description"
          content="Explore our Portfolio Dashboard to select the best plan for your investment needs. Access basic to advanced portfolio management tools."
        />
      </Helmet>

      <div className="w-full">
        {/* h-[800px]  */}
        <div className="relative bg-gray-300">  
          <div className="absolute left-0 right-0 top-6 m-auto flex flex-1 flex-col items-center gap-[108px] md:gap-[81px] sm:gap-[54px]">
            <div className="container-xs md:px-5">
              <Navbar />
            </div>  
          </div>  


          <div className="flex justify-center bg-gray-300 py-24 md:py-5">
            <div className="container-xs flex items-center justify-center md:flex-col md:px-5 ">
                <Heading size="headings" as="h2" className="text-[21px] font-semibold text-blue_gray-900 ">
                  Solutions
                </Heading>

                <div className="flex justify-center my-5">
                  <Img
                    src="/images/elipse-blue.svg"
                    className="w-[200px] h-auto"
                  />
                </div>

                <div className="flex flex-1 mt-9 flex-col items-center gap-9 font-semibold md:flex-col md:self-stretch ">
                  <div className="text-blue_gray-900 text-[28px] md:text-[24px] sm:text-[20px] leading-relaxed text-justify">
                    We have a&nbsp;
                    <span className="text-pink-a200">solution&nbsp;</span>
                    whether you service customers with a holistic view of&nbsp;
                    <span className="text-pink-a200"> multiple portfolios</span>
                    , manage their investments or run your own portfolio.
                  </div>
                  <div className="flex flex-1 md:flex-row md:self-stretch sm:flex-col">
                    <SolutionTable
                        titleText="WealthTech"
                        bodyText="Enhance your platform’s holistic view of your clients' portfolios with reliable risk analytics from TRG. 
                                  Leverage our dashboard or download bulk risk metrics through our API for seamless integration 
                                  with your own dashboards."
                        className="w-1/4"
                      />
                    
                    <SolutionTable
                        titleText="Wealth Managers / Advisors"
                        bodyText="Risk manage your client’s portfolios regardless of where they are held or whether they include liquid and/or 
                                  illiquid assets. Use our intuitive, non-technical app to keep your clients informed of their portfolio risk 
                                  and empower them to control asset rebalancing through the app’s alert system."
                        className="w-1/4"
                      />
                    
                    <SolutionTable
                        titleText="Family Offices / Individual Investors"
                        bodyText="Risk manage your family’s portfolios no matter where they are held or whether they include liquid or illiquid assets. 
                                  Optimize risk management by monitoring your portfolios’ metrics against predefined concentration limits."
                        className="w-1/4"
                      />
                    
                    <SolutionTable
                        titleText="Institutional Investors"
                        bodyText={
                          <>
                            <p>Leverage real-time risk metrics updates through our dashboard or use our API to download bulk metrics for seamless 
                              integration with your own dashboard.</p>
                            <p className="mt-4 text-red-500">
                               Under Development
                            </p>
                          </>
                        }
                        
                        className="w-1/4"

                        
                      />
                  </div>
                </div>
            </div>
          </div>
        </div>
        
        <div>
          <div className="flex flex-col items-center bg-gray-900_02 py-12 md:py-5">
              <div className="container-xs mt-[50px] flex flex-col gap-[116px] md:gap-[87px] md:px-5 sm:gap-[58px]">
                <Footer />
              </div>
          </div>
        </div>
      </div>
      
    </>
  );
}


